module.exports = __webpack_public_path__ + "img/billicon.2decaefc.png";